export const FundSourceType = Object.freeze({
  PAYMENT_TO_ACCOUNT: 'PAYMENT_TO_ACCOUNT',
  CREDIT_INVOICE: 'CREDIT_INVOICE',
});

export const PaymentType = Object.freeze({
  PAYMENT: 'PAYMENT',
  CREDIT: 'CREDIT',
});

export const InvoiceType = Object.freeze({
  CASH: 'CASH',
  CREDIT: 'CREDIT',
  ESCROW: 'ESCROW',
  NORMAL: 'NORMAL',
  PREPAYMENT: 'PREPAYMENT',
});

export const enum MappingTargetType {
  CREDIT = 'CREDIT',
  NORMAL = 'NORMAL',
  PREPAYMENT = 'PREPAYMENT',
  INVOICE_AGGREGATION = 'INVOICE_AGGREGATION',
}

export const enum MappingTargetFamily {
  INVOICE = 'INVOICE',
  INVOICE_AGGREGATION = 'INVOICE_AGGREGATION',
}

export const enum MappingError {
  OVERPAYMENT = 'OVERPAYMENT',
  OVERUSE = 'OVERUSE',
  INVOICE_NOT_FOUND = 'INVOICE_NOT_FOUND',
  WRONG_CURRENCY = 'WRONG_CURRENCY',
  WRONG_INVOICE_TYPE = 'WRONG_INVOICE_TYPE',
  NON_MATCHING_MERCHANT = 'NON_MATCHING_MERCHANT',
  PART_OF_INVOICE_AGGREGATION = 'PART_OF_INVOICE_AGGREGATION',
  OTHER = 'OTHER',
  DENIED_ORDER = 'DENIED_ORDER',
}

export const enum MappingStatus {
  UNMAPPED = 'Not started',
  ONGOING = 'Ongoing',
  COMPLETED = 'Completed',
}

export const invoiceSearchables = [
  'company',
  'customer number',
  'external invoice number',
  'ocr',
  'order reference id',
  'order additional reference',
  'id',
  'invoice customer email',
  'invoice customer reg number',
  'our reference',
  'your reference',
];

export const invoiceStatementSearchables = [
  'id',
  'ocr',
  'reg number',
  'invoice running numbers',
  'statement reference',
  'company name',
];
